import chevironRight from "$/cheviron-right.svg";
import { createFileRoute, useRouter } from "@tanstack/react-router";
import { LayoutHeader } from "@/Header";
import useMyPagePetInfo from "^/customer/myPage/useMyPagePetInfo";
import { SwiperDataType } from "@/SwiperX";

export const Route = createFileRoute("/customer/layout/user-pet-info")({
  component: User,
});

function User() {
  const { history } = useRouter();
  const { petList } = useMyPagePetInfo();
  console.log(petList);
  return (
    <>
      <LayoutHeader title={"반려동물 정보"} hasBackBtn hasFootPrint={false} />
      <div className="flex flex-col flex-auto bg-[#F5F5F5]">
        <div className="flex flex-col flex-auto gap-4 px-5 pt-3 rounded-t-3xl">
          <div className="mt-4">
            <div className="mb-2 font-medium">반려동물 정보</div>
            {/* 반복 */}
            {petList?.map((item: SwiperDataType) => (
              <div
                className="bg-white border-2 border-[#E9E9E9] rounded-xl mb-2"
                key={item.seq}
              >
                <button
                  className="flex justify-between items-center px-4 py-3 w-full"
                  onClick={() =>
                    history.push(
                      `/customer/layout/user-pet-info-chg?petSeq=${item.seq}`
                    )
                  }
                >
                  <span>
                    {item.title} ({item.description1})
                  </span>
                  <img src={chevironRight} alt="반려동물 정보" />
                </button>
              </div>
            ))}
            {/* 반복 */}
            {/* <div className="bg-white border-2 border-[#E9E9E9] rounded-xl">
              <button
                className="flex justify-between items-center px-4 py-3 w-full"
                onClick={() => history.push("/customer/layout/user-pet-info")}
              >
                <span>똘망이 (2년4개월)</span>
                <img src={chevironRight} alt="반려동물 정보" />
              </button>
            </div> */}
            {/* 반복 */}
            <div className="flex justify-center">
              <button
                className="py-2 mt-2 w-full bg-white rounded border border-gray-400"
                onClick={() =>
                  history.push("/customer/layout/user-pet-info-add")
                }
              >
                <p>반려동물 추가</p>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
